module.exports = __webpack_public_path__ + "img/github.e3c92e5a.svg";